import React from 'react';
import { ProposalStage, StageState, STAGE_ORDER, STAGE_LABELS } from '../../../utils/proposalStage';

/**
 * Barra de ESTÁGIOS da proposta — Montagem → Documentos → Envio → Disputa →
 * Resultado. Substitui as 3 abas ("Itens & Preços" / "Termos do Portal" /
 * "Documentos e PDF") que não contavam história nenhuma: agora a tela diz onde
 * a proposta está e o que falta.
 *
 * É NAVEGAÇÃO, não wizard: todo estágio é clicável a qualquer momento (o
 * trabalho real é não-linear — volta-se pra Montagem depois da disputa pra
 * adequar preço). O estágio "atual" é só destaque visual.
 *
 * Visual: mesmo vocabulário do stepper de jobs do módulo (bolinha + conector).
 */

interface Props {
  stage: StageState;
  viewStage: ProposalStage;
  onSelect: (s: ProposalStage) => void;
}

export default function StageBar({ stage, viewStage, onSelect }: Props) {
  const doneSet = new Set(stage.done);

  return (
    <div className="flex items-stretch gap-0 overflow-x-auto">
      {STAGE_ORDER.map((s, idx) => {
        const isDone = doneSet.has(s);
        const isCurrent = stage.current === s;
        const isViewing = viewStage === s;
        const summary = stage.summary[s];

        // dot: concluído = ✓ neutro (L5, 24/10/2026: andamento é neutro; o ✓ já diz "feito"); atual = claro, posição
        // por contraste, sem matiz; futuro = vazio.
        const dotCls = isDone
          ? 'bg-transparent border-slate-400 text-slate-200'
          : isCurrent
            ? 'bg-slate-200 border-slate-200 text-slate-900'
            : 'bg-central-cartao border-central-borda text-slate-500';

        return (
          <button
            key={s}
            type="button"
            onClick={() => onSelect(s)}
            aria-current={isViewing ? 'step' : undefined}
            className={`group relative flex-1 min-w-[132px] text-left px-3 py-2 border-b-2 transition-colors ${
              isViewing
                ? 'border-white bg-central-elevado'
                : 'border-transparent hover:bg-central-elevado'
            }`}
            title={summary || STAGE_LABELS[s]}
          >
            <div className="flex items-center gap-2">
              <span className={`flex items-center justify-center w-5 h-5 shrink-0 rounded-full border-2 text-[10px] font-bold ${dotCls}`}>
                {isDone ? '✓' : idx + 1}
              </span>
              <span className={`text-xs font-medium truncate ${isViewing ? 'text-white' : isCurrent ? 'text-slate-200 font-semibold' : isDone ? 'text-slate-300' : 'text-slate-500'}`}>
                {STAGE_LABELS[s]}
              </span>
            </div>
            <div className="pl-7 text-[10px] text-slate-500 truncate">
              {summary || (isCurrent ? 'em andamento' : isDone ? 'concluído' : '—')}
            </div>
          </button>
        );
      })}
    </div>
  );
}
